import LearnMore from './LearnMore';

const learnMoreConfig = {
  name: 'learnMore',
  class: LearnMore,
  options: {
    boxId: 'learn_more',
    boxActiveClass: 'landing-learn-more--active',
    boxClosedClass: 'landing-learn-more--closed',
  },
};

export default learnMoreConfig;



// WEBPACK FOOTER //
// ./client/js/components/LearnMore/learnMoreConfig.js